import React, {FC} from 'react';
import {Navigate, useParams} from "react-router-dom";
import {assert} from "../../assert";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {activeVideoActions} from "../../state-slices/ActiveVideo";

interface DirectPlayProjectProps {}

const DirectPlayProject: FC<DirectPlayProjectProps> = () => {
    const {safeProjectName, frame, runSafeName, clipName} = useParams();
    assert(safeProjectName, 'no safe project name found');

    const project = useAppSelector(s => s.activeVideoSlice.projectState.currentProject);
    const projects = useAppSelector(s => s.activeVideoSlice.projectState.availableProjects);

    const dispatch = useAppDispatch();
    const matchingProject = projects.find(p => p.safeName === safeProjectName);
    assert(matchingProject, `no matching project for ${safeProjectName}`);
    dispatch(activeVideoActions.selectProject(matchingProject.s3Key));

    if(runSafeName) {
        dispatch(activeVideoActions.selectRun(runSafeName));
    }
    if(clipName) {
        dispatch(activeVideoActions.selectClip(clipName));
    }
    if(frame) {
        dispatch(activeVideoActions.seekVideoToFrameOnLoad(+frame));
    }

    return <>Loading...
        {<Navigate to={`/projects/play/${project?.safeName}`} replace={true}/>}</>
};

export default DirectPlayProject;
